export default "__VITE_ASSET__DfFeOXoF__"